import React, { useState,useEffect } from 'react'; 
import Header from './Header'
import Dealer from './Dealer'
import '../CSS/Style.css'
import axios from 'axios'

const Home = () => { 
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');

    useEffect(() => {
            let token = sessionStorage.getItem("token")
            let email = sessionStorage.getItem("email")
                  if(!token || !email){
                      window.location.href="/signin"
                  }
                  else{
                    setToken(token)
                    setEmail(email)
                    const config = {
                      headers: { Authorization: `Bearer ${token}` }
                  };
                    axios.get("https://api.mahirefrigeration.com/api/validateToken",config)
                    .then(res=>{
                      if(res.data==='User validation failed'){
                        sessionStorage.clear();
                        window.location.href='/signin'
                      }
                    })
                  }
      },[]);
      
	return ( 
		<div className='first_sec_ran' style={{overflow:"scroll"}}> 
      <Header/>
      <Dealer/>
		</div> 
	); 
} 
export default Home;
